// Code review - Completed
// Documentation-Completed
import React, { useEffect, useState } from "react";// React and state hooks
import InputText from "../ReusableComponents/InputText";// Reusable components
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import MainLayout from "../components/MainLayout";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";// Services (API Calls)
import { shiftMasterHeader } from "../components/HeaderAttribute"; // Header Configuration
import GridPage from "../components/GridPage";// Grid and Popup Components
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import MainPopup from "../popup-containers/MainPopup";
import ShiftMasterPopup from "../popup-containers/ShiftMasterPopup";
import toast from "react-hot-toast";// Notifications and Loader
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";
import TextArea from "../ReusableComponents/TextArea";

const ShiftMaster = () => {
  // usestate values
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [popUpData, setPopUpData] = useState(null);
  const [rowIndex, setRowIndex] = useState(null);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [bindShiftMasterData, setBindShiftMasterData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [MstShiftId, setMstShiftId] = useState("");
  const [errors, setErrors] = useState({})
  var createdBy = sessionStorage.getItem("createdBy"); // user session

  var mstClientId = sessionStorage.getItem("MstClientId"); 
  
  const [formFields, setFormFields] = useState({  //Form field value
    shiftName: "",
    fromTime: "",
    toTime: "",
    description:"",
  });


  // bind gird datas
  useEffect(() => {

    BindShiftMasterData();
  }, []);

  
  // Fetch data from API and bind to table
  const BindShiftMasterData = async () => {

    const data = {
      mstClientId:mstClientId,
    };
setIsLoading(true); 
    const response = await BindPostAPI( data,"ShiftAPI/BindShift");
    
    if (response && response.data) {
      setBindShiftMasterData(response.data.Table);


setIsLoading(false); 
    } else {
      setBindShiftMasterData([]);
    }
  };

  // Time formatting from 24-hour format to 12-hour format
  const formatTimeForDisplay = (timeString) => {
    if (!timeString) return '';

    // Extract just the time part if it's a full datetime string
    const timePart = timeString.includes('T')
      ? timeString.split('T')[1]
      : timeString;

    // Remove seconds if present
    const [hours, minutes] = timePart.split(':');

    const hour = parseInt(hours, 10);
    const period = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;

    return `${hour12}:${minutes} ${period}`;
  };

  // Handle changes in input fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
  
    // Allow only alphanumeric characters (letters, numbers, spaces)
    if (name === "shiftName") {
      const regex = /^[A-Za-z0-9 ]*$/;
      if (!regex.test(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          shiftName: "Only alphabets and numbers are allowed",
        }));
        return; // Stop further update if invalid
      }
    }
  
    setFormFields((prev) => ({ ...prev, [name]: value }));
  
    if (value.trim() !== "") {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };

  // Validation for onblur
  const handleBlur = (e) => {
    const { name, value } = e.target;
    const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() === "" ? `Enter the ${formattedName}.` : "",
    }));
  };

const handleBlurToTime = (e) => {
  const { name, value } = e.target;

  const fromTime = formFields.fromTime;
  const toTime = value;

  // Basic empty validation
  if (toTime.trim() === "") {
    setErrors((prev) => ({
      ...prev,
      toTime: "Enter the To Time.",
    }));
    return;
  }
debugger;
  // Compare times (HH:MM format works directly as string or convert to Date)
  if (fromTime && toTime <= fromTime) {
    toast.error("To Time must be greater than From Time.", {
      duration: 1000,
      position: "top-center",
    });

    // Clear To Time field
    setFormFields((prev) => ({
      ...prev,
      toTime: "",
    }));

    // Set error
    setErrors((prev) => ({
      ...prev,
      toTime: "To Time must be greater than From Time.",
    }));

    return;
  }

  // Clear error if valid
  setErrors((prev) => ({
    ...prev,
    toTime: "",
  }));
};
const handleBlurFromTime = (e) => {
  const { name, value } = e.target;

  const fromTime = value;
  const toTime = formFields.toTime;

  // Basic empty validation
  if (toTime.trim() === "") {
    setErrors((prev) => ({
      ...prev,
      toTime: "Enter the To Time.",
    }));
    return;
  }
debugger;
  // Compare times (HH:MM format works directly as string or convert to Date)
  if (fromTime && toTime <= fromTime) {
    toast.error("To Time must be greater than From Time.", {
      duration: 1000,
      position: "top-center",
    });

    // Clear To Time field
    setFormFields((prev) => ({
      ...prev,
      toTime: "",
    }));

    // Set error
    setErrors((prev) => ({
      ...prev,
      toTime: "To Time must be greater than From Time.",
    }));

    return;
  }

  // Clear error if valid
  setErrors((prev) => ({
    ...prev,
    toTime: "",
  }));
};

  // Form validation 

  const validateForm = () => {
    const newErrors = {};
    if (!formFields.shiftName) {
      newErrors.shiftName = "Enter the Shift Name ";
    } else if (!/^[A-Za-z0-9 ]+$/.test(formFields.shiftName)) {
      newErrors.shiftName = "Only alphabets and numbers are allowed";
    }
  
    if (!formFields.fromTime) newErrors.fromTime = " Enter the From Time ";
    if (!formFields.toTime) newErrors.toTime = "Enter the To Time ";
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  // const validateForm = () => {
  //   const newErrors = {};
  //   if (!formFields.shiftName) newErrors.shiftName = "Enter the Shift Name ";
  //   if (!formFields.fromTime) newErrors.fromTime = " Enter the From Time ";
  //   if (!formFields.toTime) newErrors.toTime = "Enter the To Time ";

    
  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };


  // Handles insert, update, delete, active, and inactive operations

  const handleSubmit = async (rowIndex, flag) => {

    setSubmitBtnDisabled(true);
    setIsLoading(true);

    const isValid = validateForm();
    if (flag == 1 || flag == 2) {
      // Add or Edit

      if (!isValid) {
        setIsOpen(true);
        setIsLoading(false);
        setSubmitBtnDisabled(false);
      }
      if (isValid) {
        setIsOpen(false);
        setIsLoading(true);

        // Get current date for dummy date part
        const currentDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD

        // Combine with time inputs
        const fromDateTime = `${currentDate}T${formFields.fromTime}`;
        const toDateTime = `${currentDate}T${formFields.toTime}`;

        const data = {
          mstShiftId: MstShiftId ? MstShiftId : 0,
          mstClientId:mstClientId,
          shiftName: formFields.shiftName,
          fromTime: fromDateTime,  // Now in full DateTime format
          toTime: toDateTime,      // Now in full DateTime format
          description:formFields.description,
          createdBy: createdBy,
          flag: flag,
        };



        const response = await IUDAPI([data], "ShiftAPI/IUDShift");
        if (flag == 1) {

          if (response.data.Table[0].Result === "S") {
            toast.success("Shift data inserted successfully! 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Shift data insert failed 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Shift data modified successfully! 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Shift data modification failed 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
      }
    } else {

      
      const data = {
        mstShiftId: MstShiftId ? MstShiftId : 0,
        createdBy: createdBy,
        flag: flag,
      };
      const response = await IUDAPI([data], "ShiftAPI/IUDShift");
      // Delete (3), Block (4), Unblock (5)
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success("Shift data deleted successfully! 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to delete Shift data. 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success("Shift data Inactivated successfully! 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Shift data Inactivated failed 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success("Shift data activated successfully! 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Shift data activated failed! 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      }
    }
  };


  //Reset form
  const cancel = () => {
    setVisibleAdd(false);
    setIsLoading(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setFormFields({
      shiftName: "",
      fromTime: "",
      toTime: "",
      description:""
    });
    setErrors({});
    setpopUpOpen(false);
    setRowIndex(null);
    setViewDetails(false);
    setDeleteDetails(false);
    setBlockDetails(false);
    setUnBlockDetails(false);
    BindShiftMasterData();
    setSubmitBtnDisabled(false);
  };
  // Opens form to add a new shift
  const handleAddShiftClick = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
  };
  // Opens form to edit an existing shift
  const handleEdit = (rowIndex) => {

    setRowIndex(rowIndex);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setMstShiftId(bindShiftMasterData[rowIndex].MstShiftId)
    setFormFields({
      ...formFields,
      shiftName: bindShiftMasterData[rowIndex].ShiftName,
      fromTime: bindShiftMasterData[rowIndex].FromTime,
      toTime: bindShiftMasterData[rowIndex].ToTime,
      description: bindShiftMasterData[rowIndex].Description,
    });
  };
  // Opens popup with respective flag type (view/delete/block/unblock)
  const handlePopupAction = (rowIndex, flag) => {

    setpopUpOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }
    const rowData = bindShiftMasterData[rowIndex];
    setMstShiftId(bindShiftMasterData[rowIndex].MstShiftId);

    setPopUpData(rowData);


  };

  return (

    <MainLayout pageName="2">
      {/* Loader */}
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />

      {/* Grid View */}
      {visibleTable && (

        <GridPage
          header={shiftMasterHeader}
          title="Shift"
          records={bindShiftMasterData.map(item => ({
            ...item,
            FromTime: formatTimeForDisplay(item.FromTime),
            ToTime: formatTimeForDisplay(item.ToTime)
          }))}
          // records={ bindShiftMasterData}
          handleEdit={handleEdit}
          handleAction={handlePopupAction}
          showAdd={handleAddShiftClick}
          blockview={true}
        />
      )}
      {/* Add/Edit Form */}
      {visibleAdd && (

        <div className="w-full">
          <AddScreenTitle
            addScreenTitle={addScreenTitle}
            updateScreenTitle={updateScreenTitle}
            title="Shift"
          />
          {/* <div className="mx-auto mt-16 md:w-2/5 w-full flex items-center justify-center">
            <div className="relative w-full h-full max-w-xl md:h-auto">
              <div className="relative bg-white rounded-lg shadow">
                <div className="px-6 py-6 lg:px-8"> */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
            <InputText
              inputType="text"
              title="Shift Name"
              name="shiftName"
              content={formFields.shiftName}
              controlFunc={handleInputChange}
              controlFuncBlur={handleBlur}
              classStar="text-red-500"
              isRequired={true}
              errorMessage={errors.shiftName}
            />
            <InputText
              inputType="time"
              title="From Time"
              name="fromTime"
              content={formFields.fromTime}
              controlFunc={handleInputChange}
              controlFuncBlur={handleBlurFromTime}
              classStar="text-red-500"
              disabled={false}
              isRequired={true}
              errorMessage={errors.fromTime}
            />
            <InputText
              inputType="time"
              title="To Time"
              name="toTime"
              content={formFields.toTime}
              controlFunc={handleInputChange}
              controlFuncBlur={handleBlurToTime}
              classStar="text-red-500"
              disabled={false}
              isRequired={true}
              errorMessage={errors.toTime}
            />
          </div>
          <div className="p-4">

            <TextArea
              title="Description"
              rows={3}
              name="description"
              content={formFields.description}
              resize={false}
              placeholder="Enter description"
              controlFunc={(e) =>
                setFormFields((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
              controlFuncBlur={() => { }}
              disabled={false}
              // tabIndex="0"
              errorMessage={errors.description}
            />

          </div>
          <div className="flex justify-center mt-6">
            <Buttons
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}

              viewSaveButton={false}
              disabledBtn={submitBtnDisabled || isLoading}
              handleSubmit={handleSubmit}
              cancel={cancel}
            />
            {/* </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      )}
      {/* Error Popup */}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}

      {/* Main Popup (View/Delete/Block/Unblock) */}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(false)}
      >
        <div>
          <PopUpScreenTitle
            title="Shift"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <ShiftMasterPopup data={popUpData} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default ShiftMaster;
